import { Button, Dialog, Grid, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/styles';
import React, { useContext } from 'react';
import { poppins500, poppins600 } from 'theme/common.style';
import { useHistory } from 'react-router-dom';
import { datacontext } from 'modules/AppLayout/AppLayout';

const WarningIconRED = () => {
  return (
    <svg
      width="102"
      height="102"
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M89.25 51C89.25 29.8828 72.1172 12.75 51 12.75C29.8828 12.75 12.75 29.8828 12.75 51C12.75 72.1172 29.8828 89.25 51 89.25C72.1172 89.25 89.25 72.1172 89.25 51Z"
        stroke="#F27474"
        stroke-width="5"
        stroke-miterlimit="10"
      />
      <path
        d="M63.75 63.75L38.25 38.25"
        stroke="#F27474"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M38.25 63.75L63.75 38.25"
        stroke="#F27474"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const CampaignRestrictedPopup = ({ open, agentBuyerBinderId, setOpen }) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const history = useHistory();
  const { setShowMessage, setMessagedata } = useContext(datacontext);
  const handleContactAgent = () => {
    setShowMessage(true);
    setMessagedata({ binderId: agentBuyerBinderId });
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => {}}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            maxWidth: '464px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '30px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          },
        }}
      >
        <Grid
          container
          height={'100%'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Grid
            item
            xs={12}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <WarningIconRED />
            <Typography
              sx={{
                ...poppins600,
                fontSize: matchessm ? '18px' : '28px',
                lineHeight: '39px',
                color: '#545454',
              }}
            >
              Campaign Restricted
            </Typography>
            <Typography
              sx={{
                ...poppins600,
                fontSize: matchessm ? '18px' : '28px',
                lineHeight: '39px',
                color: '#545454',
              }}
            >
              Unconditional Offers Only
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Typography
              sx={{
                ...poppins500,
                fontSize: '16px',
                color: '#797979',
                textAlign: 'center',
              }}
            >
              Your offer has been unsuccessful.
              <br />
              At this time the campaign is only accepting unconditional offers.
              <br />
              <br />
              Please submit an unconditional offer to proceed.
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={'center'}
            gap={2}
            marginTop={matchessm ? '15px' : 5}
          >
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={handleContactAgent}
              >
                Contact Agent
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                  cursor: 'pointer',
                }}
                onClick={() => setOpen(false)}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default CampaignRestrictedPopup;
